import { render, staticRenderFns } from "./DetailPaginator.vue?vue&type=template&id=02a95f62&"
import script from "./DetailPaginator.vue?vue&type=script&lang=js&"
export * from "./DetailPaginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports